import { useState } from 'react';
import { TicketList } from '../../Atendimentos/TicketList';
import { TicketDetails } from '../../Atendimentos/TicketDetails';
import { TicketForm } from '../../Atendimentos/TicketForm';

type View = 'list' | 'details' | 'form' | 'edit';

interface TicketManagementProps {
  initialTicketId?: string | null;
}

export function TicketManagement({ initialTicketId }: TicketManagementProps = {}) {
  const [view, setView] = useState<View>(initialTicketId ? 'details' : 'list');
  const [selectedTicketId, setSelectedTicketId] = useState<string | null>(initialTicketId || null);

  const handleViewDetails = (ticketId: string) => {
    setSelectedTicketId(ticketId);
    setView('details');
  };

  const handleCreateNew = () => {
    setSelectedTicketId(null);
    setView('form');
  };

  const handleEdit = (ticketId: string) => {
    setSelectedTicketId(ticketId);
    setView('edit');
  };

  const handleGoBack = () => {
    setSelectedTicketId(null);
    setView('list');
  };

  const handleSuccess = () => {
    setSelectedTicketId(null);
    setView('list');
  };

  switch (view) {
    case 'details':
      return (
        <TicketDetails
          ticketId={selectedTicketId!}
          onGoBack={handleGoBack}
          onEdit={handleEdit}
        />
      );

    case 'form':
      return (
        <TicketForm
          onGoBack={handleGoBack}
          onSuccess={handleSuccess}
        />
      );

    case 'edit':
      return (
        <TicketForm
          ticketId={selectedTicketId!}
          onGoBack={handleGoBack}
          onSuccess={handleSuccess}
        />
      );

    default:
      return (
        <TicketList
          onViewDetails={handleViewDetails}
          onCreateNew={handleCreateNew}
          onEdit={handleEdit}
        />
      );
  }
}